import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';
import Lightbox from 'react-image-lightbox';
import axios from 'axios';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
// import syrupGradesBG from '../media/background5.jpg';
import syrupGradesBG from '../media/maplechartback.jpg';
import syrupGradesChart from '../media/syrupgradeschart_edited.jpg';
import printerIcon from '../media/printIcon.png';

export default class SyrupGradesSection extends Component {
  static propTypes = {
     scrollToSection: PropTypes.func,
     scrollToSectionParam: PropTypes.string,
     windowWidth: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      lightboxOpen: false,
      lightboxIndexToOpen: 0
    };
  }

  componentWillMount() {
    //this.setSyrupGradesChartURL();
  }

  componentDidMount() {
  }

  printInLightbox = () => {
    let printArea = window.open('', 'PRINT', 'height=726,width=1175');
    printArea.document.write('<html><head><title>' + document.title  + '</title>');
    printArea.document.write('</head><body >');
    //printArea.document.write('<h1>' + document.title  + '</h1>');
    printArea.document.write('</head><body >');
    printArea.document.write(`<img src='https://s3.amazonaws.com/pattersonmaplefarmsstorage/syrupgradeschart/syrupgradeschart_edited.jpg'></img>`);
    printArea.document.write('</body></html>');
    printArea.document.close();
    printArea.focus();
    printArea.print();
    printArea.close();
  }

  render() {
    const PrinterToolbarButton_ForLightBox = (
      <Button style={{width: "28px", height: "33px", cursor: "pointer", 
                    backgroundImage: `url(${printerIcon})`, backgroundPosition: "center", backgroundRepeat: "no-repeat"}} 
              src={require("../media/printIcon.png")}
              onClick={() => this.printInLightbox() } >
      </Button>
    );

    return (
	  <FluidContainer id="syrupGradesSectionID" fluid>
	    <InternalContainer >
		  <h1>Syrup Grades</h1>
		  <Row >
			<Col xs="12" lg="5">
			  <p>Prior to 2015, each state had a maple syrup grading system of its own. 
           In 2015, the USDA went through the process and developed a uniform grading system. 
           This is now the standard to go by. Please use this chart for conversion from the old PA system to the new US system.
			  </p>
			</Col>
			<SyrupChartCol xs="12" lg="7">
		  		<SyrupChartImg src={syrupGradesChart} onClick={() => {this.setState({ lightboxOpen:true }) }}></SyrupChartImg>
			</SyrupChartCol>
		  </Row>

		  
		  <OpenChartButton  onClick={() => {this.setState({ lightboxOpen:true }) }}>
			<p>{this.props.windowWidth < 577 ? "Syrup Grade Chart" : "View Syrup Grade Chart"}</p>
		  </OpenChartButton>

	      {this.state.lightboxOpen ? 
	        <Lightbox mainSrc={syrupGradesChart} 
	          onCloseRequest={() => this.setState({lightboxOpen: false})}
            imageTitle={"Syrup Grade Chart"} />
	      : ""
	      }
	    </InternalContainer>
	  </FluidContainer>
    );
  }
}

const SyrupChartCol = styled(Col)`
  transition: all 0.5s;
  :hover { transform: translateY(6px); }
  cursor: pointer;
`;

const SyrupChartImg = styled.img`
	height: auto;
	width: 100%;
`;

const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${syrupGradesBG}); 
	
	/*
    background-size: 100%; /* size the background image at 100% like any responsive img tag */
    background-position: top center;
    background-repeat:no-repeat;
    */
`;

const InternalContainer = styled(Container)`
	text-align: center;
	h1 { 
		margin: 0 0 20px 0;
	}
	p { text-align: left; margin: 0 0 20px 0;}
`;

const OpenChartButton = styled(Button)`
  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 250px;
  ${media.sm` width: 290px; `}
  ${media.lg` width: 340px;`}
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;
  margin: 15px 0 0 0;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/SyrupGradesSection.js